import "react-multi-carousel/lib/styles.css";
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './page/Home';
import MovieDetailPage from "./page/MovieDetailPage"
import MoviesPage from './page/MoviesPage';
import NavbarMenu from './component/NavbarMenu';

//3개의 페이지 - home/movie/moviedetail -> router
// 홈페이지에 배너가 있음
// 데이터가 도착하면 loading ->false/도착전 loading-true가 됨

// 4가지 섹션 - now playing/popular/top rated/upcoming
// 각 영화에 마우스를 올리면 제목/장르/평점/인기도/청불 정보
// 영화를 슬라이드로 처리 -> 넘기면서 영화정보를 볼 수 있다.
// 각 영화를 클릭 -> 디테일 정보 페이지
// trailer 를 누르면 모달창으로 예고편을 볼 수 있다.
function App() {
  return (
    <div>
      <NavbarMenu />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/movies" element={<MoviesPage />} />
        <Route path="/movies/:id" element={<MovieDetailPage />} />
      </Routes>
    </div>
  );
}

export default App;
